import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../Shared/Redux/store';
const initialState = {
  editStaffData: null,
  isAddStaffModalOpen: false,
  isAddTeacherModalOpen: false,
  isAssignModalOpen: false,
  staffMetaData: null,
};

const StaffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setEditStaffData: (state, action: PayloadAction<any>) => {
      state.editStaffData = action.payload;
    },

    setIsAddStaffModalOpen: state => {
      state.isAddStaffModalOpen = !state.isAddStaffModalOpen;
    },
    setIsAddTeacherModalOpen: state => {
      state.isAddTeacherModalOpen = !state.isAddTeacherModalOpen;
    },
    setStaffMetaData: (state, action: PayloadAction<any>) => {
      state.staffMetaData = action.payload;
    },
  },
});

export const selectisAddStaffModalOpen = (state: RootState) =>
  state.staff.isAddStaffModalOpen;

export const selectisAddTeacherModalOpen = (state: RootState) =>
  state.staff.isAddTeacherModalOpen;

export const selectEditStaffData = (state: RootState) =>
  state.staff.editStaffData;

export const selectStaffMetaData = (state: RootState) =>
  state.staff.staffMetaData;

export const {
  setEditStaffData,
  setIsAddStaffModalOpen,
  setIsAddTeacherModalOpen,
  setStaffMetaData,
} = StaffSlice.actions;
export default StaffSlice.reducer;
